import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import moment from "moment";
import { toast } from "react-toastify";

const AttendanceForm = (props) => {
  const format = "HH:mm";
  const frmRef = useRef({});
  const [wareHouseData, setWareHouseData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const { sendRequest: getWarehouseData } = useHttp();
  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setWareHouseData(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getemployeeData } = useHttp();
  const FillEmployeeData = (wId) => {
    var attendanceDate = moment(frmRef.current.date.value).format("DD/MM/YYYY");

    getemployeeData(
      {
        url: `/api/employeeForAttendance/?orgId=${localStorage.getItem(
          "orgId"
        )}&&attendanceDate=${attendanceDate}&&warehouseId=${wId}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          // setEmployeeData(res);
          const updatedEmp = res.map((employee) => ({
            ...employee,
            createdBy: parseInt(localStorage.getItem("id")),
            status: 1,
            orgId: localStorage.getItem("orgId"),
          }));

          setEmployeeData(updatedEmp);
        }
      }
    );
  };

  useEffect(() => {
    FillEmployeeData(0);
  }, [getemployeeData]);

  const handledropdownlistChange = (e, index) => {
    const value = e.target.value;
    employeeData[index].attendanceType = e.target.value;
    var newstr = employeeData;
    setEmployeeData([...employeeData]);
  };

  const handledDDLShiftChange = (e, index) => {
    const value = e.target.value;
    employeeData[index].shiftId = parseInt(e.target.value);
    var newstr = employeeData;
    setEmployeeData([...employeeData]);
  };

  const calculateTotalHours = (employee) => {
    const fromTime = moment(employee.inTime, "HH:mm");
    const toTime = moment(employee.outTime, "HH:mm");
    const overTime = parseFloat(employee.overTime) || 0;

    let totalHours;
    if (fromTime.isBefore(toTime)) {
      totalHours = toTime.diff(fromTime, "hours", true) + overTime;
    } else {
      totalHours = fromTime.diff(toTime, "hours", true) - overTime;
    }

    return totalHours.toFixed(2);
  };

  const handleTimeFieldChange = (e, index) => {
    const fieldName = e.target.id;
    const value = e.target.value;

    // //console.log(e.target.value);

    employeeData[index][fieldName] = value;

    const totalHours = calculateTotalHours(employeeData[index]);
    employeeData[index].totalHrs = totalHours;

    setEmployeeData([...employeeData]);
  };

  const { sendRequest: postEmployeeAttendance } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    postEmployeeAttendance(
      {
        url: "/api/empAttendance/",
        method: "POST",
        body: employeeData,
      },
      (data) => {
        //console.log(data);
        toast.success("Employee Attendance Added successfully");
        props.addForm(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Employee Attenance Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"Date"}>{"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"warehouse"}>{"WareHouse"}</label>

                      <select
                        className="form-control"
                        id={"warehouse"}
                        // ref={(el) => (frmRef.current["warehouse"] = el)}
                        required
                        onChange={(e) => {
                          //console.log("warehosue", e.target.value);
                          setWarehouseId(e.target.value);
                          FillEmployeeData(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {wareHouseData &&
                          wareHouseData.map((x) => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <br />
                  {employeeData && employeeData.length > 0 && (
                    <>
                      <table className="table table-bordered text-center table-sm">
                        <tr className="">
                          <th>Employee Name</th>
                          <th>Employee Code</th>
                          <th>AttendanceType</th>
                          <th>WorkingShift</th>
                          <th>Attenance</th>
                          <th>In Time</th>
                          <th>Out time</th>
                          <th>Over Time(Hrs)</th>
                          <th>Total(Hrs)</th>
                        </tr>

                        <tbody>
                          {employeeData &&
                            employeeData.map((itm, i) => {
                              return (
                                <tr key={i} className="tablerowview">
                                  <td> {itm.employeeName}</td>
                                  <td>{itm.employeeCode} </td>
                                  <td>
                                    {" "}
                                    <select
                                      id="assign_task"
                                      className="form-control"
                                      ref={(el) =>
                                        (frmRef.current["attendanceType"] = el)
                                      }
                                      value={employeeData[i].attendanceType}
                                      onChange={(e) =>
                                        handledropdownlistChange(e, i)
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Full Day">Full Day</option>
                                      <option value="Half Day">Half Day</option>
                                    </select>
                                  </td>
                                  <td>
                                    <div className="form-group-lg">
                                      <select
                                        id="assign_task"
                                        className="form-control"
                                        ref={(el) =>
                                          (frmRef.current["attendanceType"] =
                                            el)
                                        }
                                        value={employeeData[i].shiftId}
                                        onChange={(e) =>
                                          handledDDLShiftChange(e, i)
                                        }
                                      >
                                        <option value="">Select</option>
                                        <option value="1">First Shift</option>
                                        <option value="2">Second Shift</option>
                                        <option value="3">Third Shift</option>
                                      </select>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-group">
                                      <div className="custom-control custom-checkbox">
                                        <input
                                          type={"checkbox"}
                                          id={`customCheckbox-${i}`} // Use unique id for each checkbox
                                          ref={(el) =>
                                            (frmRef.current[
                                              `attendanceStatus-${i}`
                                            ] = el)
                                          }
                                          className="custom-control-input"
                                          checked={
                                            itm.attendanceStatus || false
                                          }
                                          onChange={() => {
                                            const updatedEmployeeData = [
                                              ...employeeData,
                                            ];
                                            updatedEmployeeData[
                                              i
                                            ].attendanceStatus =
                                              !itm.attendanceStatus;
                                            setEmployeeData(
                                              updatedEmployeeData
                                            );
                                          }}
                                        />
                                        <label
                                          htmlFor={`customCheckbox-${i}`} // Update the 'for' attribute to match the checkbox id
                                          className="custom-control-label"
                                        ></label>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-group-lg">
                                      <input
                                        type="time"
                                        id={"inTime"}
                                        required
                                        step="3600"
                                        ref={(el) =>
                                          (frmRef.current["inTime"] = el)
                                        }
                                        className="form-control"
                                        value={itm.inTime || ""}
                                        onChange={(e) =>
                                          handleTimeFieldChange(e, i)
                                        }
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-group-lg">
                                      <input
                                        type={"time"}
                                        id={"outTime"}
                                        required
                                        ref={(el) =>
                                          (frmRef.current["outTime"] = el)
                                        }
                                        className="form-control"
                                        value={itm.outTime || ""}
                                        onChange={(e) =>
                                          handleTimeFieldChange(e, i)
                                        }
                                      />{" "}
                                    </div>
                                  </td>
                                  <td>
                                    {" "}
                                    <input
                                      type={"number"}
                                      id={"overTime"}
                                      required
                                      ref={(el) =>
                                        (frmRef.current["overTime"] = el)
                                      }
                                      className="form-control"
                                      value={itm.overTime || ""}
                                      min="0"
                                      onChange={(e) =>
                                        handleTimeFieldChange(e, i)
                                      }
                                    />
                                  </td>
                                  <td>
                                    {" "}
                                    <input
                                      type={"text"}
                                      id={"totalHrs"}
                                      readOnly="True"
                                      ref={(el) =>
                                        (frmRef.current["totalHrs"] = el)
                                      }
                                      className="form-control"
                                      value={itm.totalHrs || 0}
                                    />{" "}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      <div className="mx-3 my-3 text-right">
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AttendanceForm;
